export default __webpack_public_path__ + "static/media/bkground.a2da13ae.png";